@if (productList().length) {
  <div class="container">
    <sirius-grid>
      <div class="product-slider-header sir-text-style-paragraph-l-default">
        <h2 class="product-slider-title sir-text-style-title-l-default" data-cy="product-slider-title">{{ title }}</h2>
        <p class="product-slider-description sir-text-style-paragraph-l-default" data-cy="product-slider-description">{{ description }}</p>
      </div>
    </sirius-grid>
    <div class="product-slider">
      <sirius-slider>
        @for (item of productList(); track item) {
          <ur-product-card
            [title]="item.title"
            [brandName]="item.brandName"
            [teaserHtml]="item.teaserHtml"
            [image]="item.image"
            [link]="item.link"
            [tags]="item.tags"
            [manufacturer]="item.manufacturer"
            [attributes]="item.attributes"
            />
        }
      </sirius-slider>
    </div>
  </div>
}
